import UserModel from '@/models/UserModel';
import { NajizImpersonationProvidersEnum } from '@/shared/Enums/NajizImpersonationProvidersEnum';
import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';

//@Module({ namespaced: true })
@Module({})
export default class UserStore extends VuexModule {
  mofaToken!: string;
  currentUserSto: UserModel = {} as UserModel;

  get mofatoken(): any {
    return this.mofaToken;
  }

  get getCurrentUserGetter(): UserModel {
    return this.currentUserSto;
  }

  get isCompanyRepresentative(): boolean {
    return (
      this.currentUserSto.isImpersonated &&
      this.currentUserSto.impersonatee.providerName ==
        NajizImpersonationProvidersEnum.OrganizationActivation
    );
  }

  @Mutation
  public setCurrentUserMUT(usr: UserModel) {
    this.currentUserSto = usr;
  }

  @Mutation
  public setMofaTken(newtoken: string): void {
    this.mofaToken = newtoken;
  }

  @Action
  public updateMofaToken(newToken: string): void {
    this.context.commit('setMofaTken', newToken);
  }

  @Action
  public setCurrentUser(user: UserModel): void {
    this.context.commit('setCurrentUserMUT', user);
  }
}
// export default UserStore;
